import { jsx } from "react/jsx-runtime";
import FormatShapesIcon from "@mui/icons-material/FormatShapes";
import { validateTidalLicense } from "../../base/index.js";
function FormatShapes(props) {
  return /* @__PURE__ */ jsx(
    FormatShapesIcon,
    {
      "data-testid": "FormatShapes",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatShapes",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
FormatShapes.tidalIconMeta = {
  categories: "miscellaneous",
  name: "FormatShapes"
};
validateTidalLicense();
export {
  FormatShapes
};
//# sourceMappingURL=FormatShapes.js.map
